import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// --- Styled Components ---
const Container = styled.div`
  padding: 2rem;
  background: linear-gradient(to right, #e0f7fa, #f1f8e9);
  min-height: 100vh;
`;

const StyledTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 2rem;
  text-align: center;
  text-transform: uppercase;
`;

const WidgetSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;
`;

const WidgetCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h3`
  color: #1b5e20;
  margin-bottom: 1rem;
`;

const StatusInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  color: #2c3e50;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

const StyledButton = styled.button`
  background-color: #27ae60;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  width: 250px;
  transition: background-color 0.3s, transform 0.2s;
  text-align: center;

  &:hover {
    background-color: #219653;
    transform: translateY(-2px);
  }
`;

const Modal = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.6);
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  width: 80%;
  max-width: 800px;
  border-radius: 12px;
  padding: 1rem;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px; right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 450px;
  border: none;
  border-radius: 8px;
`;

// --- Main Component ---
const SprayTechManagerDashboard = () => {
  const navigate = useNavigate();
  const [isAppModalOpen, setAppModalOpen] = useState(false);
  const [isTutorialModalOpen, setTutorialModalOpen] = useState(false);

  // Hardcoded for now – replace with real data later
  const pendingCount = 5;
  const completedCount = 3;
  const punchListCount = 4;

  return (
    <Container>
      <StyledTitle>Horticulture Manager Dashboard</StyledTitle>

      {/* Activity Section */}
      <WidgetSection>
        <WidgetCard>
          <SectionTitle>🗓 Today's Status</SectionTitle>
          <StatusInfo><span>Pending Applications:</span><span>{pendingCount}</span></StatusInfo>
          <StatusInfo><span>Completed Applications:</span><span>{completedCount}</span></StatusInfo>
          <StatusInfo><span>Pending Punch Lists:</span><span>{punchListCount}</span></StatusInfo>
        </WidgetCard>

        <WidgetCard>
          <SectionTitle>🎥 Quick Actions</SectionTitle>
          <StyledButton onClick={() => setTutorialModalOpen(true)}>
            Watch Tutorial Video
          </StyledButton>
          <StyledButton onClick={() => setAppModalOpen(true)}>
            View Submitted Applications
          </StyledButton>
        </WidgetCard>
      </WidgetSection>

      {/* Navigation */}
      <ButtonContainer>
        <StyledButton onClick={() => navigate('/chem-app-form')}>
          New Application
        </StyledButton>
        <StyledButton onClick={() => navigate('/manager-spray-list')}>
          Saved Applications
        </StyledButton>
        <StyledButton onClick={() => navigate('/view-punch-lists')}>
          View Punch Lists
        </StyledButton>
        <StyledButton onClick={() => navigate('/tasks')}>
          Punch Lists
        </StyledButton>
        <StyledButton onClick={() => navigate('/vehicle-maintenance')}>
          Truck Maintenance
        </StyledButton>
        <StyledButton onClick={() => navigate('/saved-incident-reports')}>
          Incident Reports
        </StyledButton>
        <StyledButton onClick={() => window.open('https://employee-safe-space.vercel.app/', '_blank')}>
          Leave Employee Feedback
        </StyledButton>
      </ButtonContainer>

      {/* Application Modal */}
      <Modal isOpen={isAppModalOpen} onClick={() => setAppModalOpen(false)}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={() => setAppModalOpen(false)}>✖</CloseButton>
          <Iframe
            src="https://rotoloconsultants.quickbase.com/nav/app/brspiu9w6/table/brt8jnu22/action/td"
            title="Services Submitted to Client"
          />
        </ModalContent>
      </Modal>

      {/* Tutorial Modal */}
      <Modal isOpen={isTutorialModalOpen} onClick={() => setTutorialModalOpen(false)}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={() => setTutorialModalOpen(false)}>✖</CloseButton>
          <Iframe
            src="https://www.youtube.com/embed/LJoA59hKZbI"
            title="Tutorial Video"
          />
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default SprayTechManagerDashboard;
